import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

const Sidebar = ({ 
  currentUser, 
  conversations, 
  activeConversation, 
  setActiveConversation,
  onNewConversation
}) => {
  const [searchTerm, setSearchTerm] = useState('');
  const navigate = useNavigate();
  
  // Filter conversations based on search term
  const filteredConversations = conversations.filter(conv => 
    conv.name.toLowerCase().includes(searchTerm.toLowerCase())
  );
  
  const handleConversationClick = (conversation) => {
    setActiveConversation(conversation);
  };
  
  const handleNewConversation = () => {
    if (onNewConversation) {
      onNewConversation();
    }
  };
  
  const handleLogout = () => {
    // Clear user data from local storage
    localStorage.removeItem('czoneUser');
    // Navigate to login page
    navigate('/');
  };
  
  return (
    <div className="sidebar">
      <div className="sidebar-header">
        <div className="sidebar-logo">
          <img src="/cdezone_logo.jpg" alt="CZone Logo" className="czone-logo-small" />
        </div>
        <div className="user-info">
          <img 
            src={currentUser.avatar || `https://ui-avatars.com/api/?name=${encodeURIComponent(currentUser.name)}&background=random`} 
            alt={currentUser.name} 
            className="avatar"
          />
          <h3>{currentUser.name}</h3>
        </div>
        <div className="sidebar-actions">
          <button className="icon-button" onClick={handleNewConversation} aria-label="New conversation">
            <i className="fas fa-comment-medical"></i>
          </button>
          <button className="icon-button" onClick={handleLogout} aria-label="Logout">
            <i className="fas fa-sign-out-alt"></i>
          </button>
        </div>
      </div>
      
      <div className="search-container">
        <div className="search-input-wrapper">
          <i className="fas fa-search search-icon"></i>
          <input
            type="text"
            placeholder="Search or start new chat"
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
            className="search-input"
          />
          {searchTerm && (
            <button 
              className="clear-search" 
              onClick={() => setSearchTerm('')}
              aria-label="Clear search"
            >
              <i className="fas fa-times"></i>
            </button>
          )}
        </div>
      </div>
      
      <div className="conversations-list">
        {filteredConversations.length > 0 ? (
          filteredConversations.map(conversation => (
            <div 
              key={conversation.id} 
              className={`conversation-item ${activeConversation?.id === conversation.id ? 'active' : ''}`}
              onClick={() => handleConversationClick(conversation)}
            >
              <img 
                src={conversation.avatar || `https://ui-avatars.com/api/?name=${encodeURIComponent(conversation.name)}&background=random`} 
                alt={conversation.name} 
                className="avatar"
              />
              <div className="conversation-info">
                <div className="conversation-header">
                  <h4>{conversation.name}</h4>
                  <span className="time">{conversation.lastMessageTime}</span>
                </div>
                <p className="last-message">
                  {conversation.lastMessage && (
                    <>
                      {conversation.lastMessageType === 'image' && <i className="fas fa-image message-icon"></i>}
                      {conversation.lastMessageType === 'file' && <i className="fas fa-file message-icon"></i>}
                      {conversation.lastMessageType === 'video' && <i className="fas fa-video message-icon"></i>}
                      {conversation.lastMessage}
                    </>
                  )}
                </p>
              </div>
            </div>
          ))
        ) : (
          <div className="no-conversations">
            <p>No conversations found</p>
            <button className="start-new-btn" onClick={handleNewConversation}>
              Start a new conversation
            </button>
          </div>
        )}
      </div>
    </div>
  );
};

export default Sidebar;
